// Aqui se centralizan los strings de las rutas
export class RouterNames {
    public static Login: string = 'Login';
    public static mainlayout: string = 'mainlayout';
    public static Home: string = 'Home';
    public static empresas:string="empresas";
    public static departamentos:string="departamentos";
    public static empresaslista:string="empresaslista";
    public static departamentoslista:string="departamentoslista";
    public static cerrar_session:string="cerrar_session";
    public static notificaciones:string="notificaciones";
    public static table:string="table";
    public static tablas:string="tablas";
    public static usuarios:string="usuarios";
    public static usuarioslista:string="usuarioslista";
    public static usuariosformulario:string="usuariosformulario";
    public static proyectos:string="proyectos";
    public static proyectoslista:string="proyectoslista";
    public static mi_perfil:string="mi_perfil";
    public static proyectosformulario:string="proyectosformulario";
    public static proyectoskanban:string="proyectoskanban";
    public static administracion:string="administracion";
    public static administracion_proyectos:string="administracion_proyectos";
    public static administracion_proyectos_prioridades:string="administracion_proyectos_prioridades";
    public static administracion_proyectos_prioridadeslista:string="administracion_proyectos_prioridadeslista";
    public static administracion_proyectos_fases:string="administracion_proyectos_fases";
    public static administracion_proyectos_faseslista:string="administracion_proyectos_faseslista";
    public static administracion_incidencias:string="administracion_incidencias";
    public static administracion_incidencias_prioridades:string="administracion_incidencias_prioridades";
    public static administracion_incidencias_prioridadeslista:string="administracion_incidencias_prioridadeslista";
    public static administracion_incidencias_estados:string="administracion_incidencias_estados";
    public static administracion_incidencias_estados_lista:string="administracion_incidencias_estados_lista";
    public static administracion_incidencias_categorias:string="administracion_incidencias_categorias";
    public static administracion_incidencias_categorias_lista:string="administracion_incidencias_categorias_lista";
    public static todas_incidencias:string="todas_incidencias";
    public static administracion_tareas:string="administracion_tareas";
    public static administracion_tareas_estados:string="administracion_tareas_estados";
    public static administracion_tareas_estados_lista:string="administracion_tareas_estados_lista";
    public static administracion_tareas_categorias:string="administracion_tareas_categorias";
    public static administracion_tareas_categorias_lista:string="administracion_tareas_categorias_lista";
    public static gruposlista:string="gruposlista";
    public static grupos:string="grupos";
    public static gruposformulario:string="gruposformulario";
    public static todas_tareas:string="todas_tareas";
    public static lostpwd:string="lostpwd";
    public static confirm_new_password:string="confirm_new_password";
    public static instalacion:string="instalacion";
    public static inventario:string="inventario";
    public static inventario_treeview:string="inventario_treeview";
    public static inventario_formulario:string="inventario_formulario";
    public static handlerinventario_formulario:string="handlerinventario_formulario";
    public static inventario_tareas:string="inventario_tareas";
    public static inventario_incidencias:string="inventario_incidencias";
    public static inventario_proyectos:string="inventario_proyectos";
    public static rol:string="rol";
    public static rollista:string="rollista";
    public static rolformulario:string="rolformulario";
    public static administracion_tareas_plantillas:string="administracion_tareas_plantillas";
    public static administracion_tareas_plantillas_lista:string="administracion_tareas_plantillas_lista";
    public static administracion_tareas_plantillas_formulario:string="administracion_tareas_plantillas_formulario";
    public static qr:string="qr";
    public static todas_tareas_movil:string="todas_tareas_movil";
    public static todas_tareas_movil_formulario:string="todas_tareas_movil_formulario";
    public static subinventarios:string="subinventarios";
    public static todas_incidencias_lista_movil:string="todas_incidencias_lista_movil";
    public static incidencias_movil:string="incidencias_movil";
    public static readqr_inventario:string="readqr_inventario";
    public static mainprintinglayout:string="mainprintinglayout";
    public static printinginventario:string="printinginventario";
    public static mediciones_tecnicas_inventario:string="mediciones_tecnicas_inventario";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    
}
